export default __webpack_public_path__ + "static/media/Terrazo_T.ef4830b6.jpg";